/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CACertificateSignatureAlgorithm } from '../model';
// @ts-ignore
import type { CAKeyUsageFilter } from '../model';
// @ts-ignore
import type { CertificateRequestHandlerDetails } from '../model';
// @ts-ignore
import type { Match } from '../model';
// @ts-ignore
import type { NewCAResponse } from '../model';
// @ts-ignore
import type { NewCASubjects } from '../model';
// @ts-ignore
import type { NewRequest } from '../model';
// @ts-ignore
import type { PendingRequest } from '../model';
// @ts-ignore
import type { X500PrincipalRequest } from '../model';
// @ts-ignore
import type { X509CRLDetails } from '../model';
// @ts-ignore
import type { X509CertificateDetails } from '../model';
/**
 * CAApi - axios parameter creator
 * @export
 */
export const CAApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} rootDaysValid 
         * @param {number} intermediateDaysValid 
         * @param {CAControllerCreateCARootKeyLengthEnum} rootKeyLength 
         * @param {CAControllerCreateCAIntermediateKeyLengthEnum} intermediateKeyLength 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {NewCASubjects} newCASubjects 
         * @param {string} [crlDistributionPoint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerCreateCA: async (rootDaysValid: number, intermediateDaysValid: number, rootKeyLength: CAControllerCreateCARootKeyLengthEnum, intermediateKeyLength: CAControllerCreateCAIntermediateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, newCASubjects: NewCASubjects, crlDistributionPoint?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rootDaysValid' is not null or undefined
            assertParamExists('cAControllerCreateCA', 'rootDaysValid', rootDaysValid)
            // verify required parameter 'intermediateDaysValid' is not null or undefined
            assertParamExists('cAControllerCreateCA', 'intermediateDaysValid', intermediateDaysValid)
            // verify required parameter 'rootKeyLength' is not null or undefined
            assertParamExists('cAControllerCreateCA', 'rootKeyLength', rootKeyLength)
            // verify required parameter 'intermediateKeyLength' is not null or undefined
            assertParamExists('cAControllerCreateCA', 'intermediateKeyLength', intermediateKeyLength)
            // verify required parameter 'signatureAlgorithm' is not null or undefined
            assertParamExists('cAControllerCreateCA', 'signatureAlgorithm', signatureAlgorithm)
            // verify required parameter 'newCASubjects' is not null or undefined
            assertParamExists('cAControllerCreateCA', 'newCASubjects', newCASubjects)
            const localVarPath = `/api/ca/createCA`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (rootDaysValid !== undefined) {
                localVarQueryParameter['rootDaysValid'] = rootDaysValid;
            }

            if (intermediateDaysValid !== undefined) {
                localVarQueryParameter['intermediateDaysValid'] = intermediateDaysValid;
            }

            if (rootKeyLength !== undefined) {
                localVarQueryParameter['rootKeyLength'] = rootKeyLength;
            }

            if (intermediateKeyLength !== undefined) {
                localVarQueryParameter['intermediateKeyLength'] = intermediateKeyLength;
            }

            if (signatureAlgorithm !== undefined) {
                localVarQueryParameter['signatureAlgorithm'] = signatureAlgorithm;
            }

            if (crlDistributionPoint !== undefined) {
                localVarQueryParameter['crlDistributionPoint'] = crlDistributionPoint;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newCASubjects, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} issuerThumbprint 
         * @param {number} nextUpdate 
         * @param {boolean} updateExistingCRL 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerCreateCRL: async (issuerThumbprint: string, nextUpdate: number, updateExistingCRL: boolean, signatureAlgorithm: CACertificateSignatureAlgorithm, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'issuerThumbprint' is not null or undefined
            assertParamExists('cAControllerCreateCRL', 'issuerThumbprint', issuerThumbprint)
            // verify required parameter 'nextUpdate' is not null or undefined
            assertParamExists('cAControllerCreateCRL', 'nextUpdate', nextUpdate)
            // verify required parameter 'updateExistingCRL' is not null or undefined
            assertParamExists('cAControllerCreateCRL', 'updateExistingCRL', updateExistingCRL)
            // verify required parameter 'signatureAlgorithm' is not null or undefined
            assertParamExists('cAControllerCreateCRL', 'signatureAlgorithm', signatureAlgorithm)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('cAControllerCreateCRL', 'requestBody', requestBody)
            const localVarPath = `/api/ca/createCRL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (issuerThumbprint !== undefined) {
                localVarQueryParameter['issuerThumbprint'] = issuerThumbprint;
            }

            if (nextUpdate !== undefined) {
                localVarQueryParameter['nextUpdate'] = nextUpdate;
            }

            if (updateExistingCRL !== undefined) {
                localVarQueryParameter['updateExistingCRL'] = updateExistingCRL;
            }

            if (signatureAlgorithm !== undefined) {
                localVarQueryParameter['signatureAlgorithm'] = signatureAlgorithm;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {number} daysValid 
         * @param {CAControllerCreateSelfSignedCertificateKeyLengthEnum} keyLength 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {X500PrincipalRequest} x500PrincipalRequest 
         * @param {boolean} [whiteList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerCreateSelfSignedCertificate: async (email: string, daysValid: number, keyLength: CAControllerCreateSelfSignedCertificateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, x500PrincipalRequest: X500PrincipalRequest, whiteList?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('cAControllerCreateSelfSignedCertificate', 'email', email)
            // verify required parameter 'daysValid' is not null or undefined
            assertParamExists('cAControllerCreateSelfSignedCertificate', 'daysValid', daysValid)
            // verify required parameter 'keyLength' is not null or undefined
            assertParamExists('cAControllerCreateSelfSignedCertificate', 'keyLength', keyLength)
            // verify required parameter 'signatureAlgorithm' is not null or undefined
            assertParamExists('cAControllerCreateSelfSignedCertificate', 'signatureAlgorithm', signatureAlgorithm)
            // verify required parameter 'x500PrincipalRequest' is not null or undefined
            assertParamExists('cAControllerCreateSelfSignedCertificate', 'x500PrincipalRequest', x500PrincipalRequest)
            const localVarPath = `/api/ca/createSelfSignedCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (daysValid !== undefined) {
                localVarQueryParameter['daysValid'] = daysValid;
            }

            if (keyLength !== undefined) {
                localVarQueryParameter['keyLength'] = keyLength;
            }

            if (signatureAlgorithm !== undefined) {
                localVarQueryParameter['signatureAlgorithm'] = signatureAlgorithm;
            }

            if (whiteList !== undefined) {
                localVarQueryParameter['whiteList'] = whiteList;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(x500PrincipalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerDeletePendingRequest: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cAControllerDeletePendingRequest', 'id', id)
            const localVarPath = `/api/ca/deletePendingRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerDeletePendingRequests: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('cAControllerDeletePendingRequests', 'requestBody', requestBody)
            const localVarPath = `/api/ca/deletePendingRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [certificates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerFinalizePendingRequest: async (certificates?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ca/finalizePendingRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


            if (certificates !== undefined) { 
                localVarFormParams.append('certificates', certificates as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CAKeyUsageFilter} keyUsageFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetAvailableCAs: async (keyUsageFilter: CAKeyUsageFilter, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'keyUsageFilter' is not null or undefined
            assertParamExists('cAControllerGetAvailableCAs', 'keyUsageFilter', keyUsageFilter)
            const localVarPath = `/api/ca/getAvailableCAs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (keyUsageFilter !== undefined) {
                localVarQueryParameter['keyUsageFilter'] = keyUsageFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetCertificateRequestHandlers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ca/getCertificateRequestHandlers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequest: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cAControllerGetPendingRequest', 'id', id)
            const localVarPath = `/api/ca/getPendingRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequests: async (firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ca/getPendingRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {Match} match 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequestsByEmail: async (email: string, match: Match, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('cAControllerGetPendingRequestsByEmail', 'email', email)
            // verify required parameter 'match' is not null or undefined
            assertParamExists('cAControllerGetPendingRequestsByEmail', 'match', match)
            const localVarPath = `/api/ca/getPendingRequestsByEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (match !== undefined) {
                localVarQueryParameter['match'] = match;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {Match} match 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequestsByEmailCount: async (email: string, match: Match, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('cAControllerGetPendingRequestsByEmailCount', 'email', email)
            // verify required parameter 'match' is not null or undefined
            assertParamExists('cAControllerGetPendingRequestsByEmailCount', 'match', match)
            const localVarPath = `/api/ca/getPendingRequestsByEmailCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (match !== undefined) {
                localVarQueryParameter['match'] = match;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequestsCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ca/getPendingRequestsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {number} daysValid 
         * @param {CAControllerRequestNewCertificateKeyLengthEnum} keyLength 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {string} certificateRequestHandler 
         * @param {X500PrincipalRequest} x500PrincipalRequest 
         * @param {string} [crlDistributionPoint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerRequestNewCertificate: async (email: string, daysValid: number, keyLength: CAControllerRequestNewCertificateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, certificateRequestHandler: string, x500PrincipalRequest: X500PrincipalRequest, crlDistributionPoint?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('cAControllerRequestNewCertificate', 'email', email)
            // verify required parameter 'daysValid' is not null or undefined
            assertParamExists('cAControllerRequestNewCertificate', 'daysValid', daysValid)
            // verify required parameter 'keyLength' is not null or undefined
            assertParamExists('cAControllerRequestNewCertificate', 'keyLength', keyLength)
            // verify required parameter 'signatureAlgorithm' is not null or undefined
            assertParamExists('cAControllerRequestNewCertificate', 'signatureAlgorithm', signatureAlgorithm)
            // verify required parameter 'certificateRequestHandler' is not null or undefined
            assertParamExists('cAControllerRequestNewCertificate', 'certificateRequestHandler', certificateRequestHandler)
            // verify required parameter 'x500PrincipalRequest' is not null or undefined
            assertParamExists('cAControllerRequestNewCertificate', 'x500PrincipalRequest', x500PrincipalRequest)
            const localVarPath = `/api/ca/requestNewCertificate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (daysValid !== undefined) {
                localVarQueryParameter['daysValid'] = daysValid;
            }

            if (keyLength !== undefined) {
                localVarQueryParameter['keyLength'] = keyLength;
            }

            if (signatureAlgorithm !== undefined) {
                localVarQueryParameter['signatureAlgorithm'] = signatureAlgorithm;
            }

            if (crlDistributionPoint !== undefined) {
                localVarQueryParameter['crlDistributionPoint'] = crlDistributionPoint;
            }

            if (certificateRequestHandler !== undefined) {
                localVarQueryParameter['certificateRequestHandler'] = certificateRequestHandler;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(x500PrincipalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerRescheduleRequest: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cAControllerRescheduleRequest', 'id', id)
            const localVarPath = `/api/ca/rescheduleRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerRescheduleRequests: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('cAControllerRescheduleRequests', 'requestBody', requestBody)
            const localVarPath = `/api/ca/rescheduleRequests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CAApi - functional programming interface
 * @export
 */
export const CAApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CAApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} rootDaysValid 
         * @param {number} intermediateDaysValid 
         * @param {CAControllerCreateCARootKeyLengthEnum} rootKeyLength 
         * @param {CAControllerCreateCAIntermediateKeyLengthEnum} intermediateKeyLength 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {NewCASubjects} newCASubjects 
         * @param {string} [crlDistributionPoint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerCreateCA(rootDaysValid: number, intermediateDaysValid: number, rootKeyLength: CAControllerCreateCARootKeyLengthEnum, intermediateKeyLength: CAControllerCreateCAIntermediateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, newCASubjects: NewCASubjects, crlDistributionPoint?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewCAResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerCreateCA(rootDaysValid, intermediateDaysValid, rootKeyLength, intermediateKeyLength, signatureAlgorithm, newCASubjects, crlDistributionPoint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerCreateCA']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} issuerThumbprint 
         * @param {number} nextUpdate 
         * @param {boolean} updateExistingCRL 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerCreateCRL(issuerThumbprint: string, nextUpdate: number, updateExistingCRL: boolean, signatureAlgorithm: CACertificateSignatureAlgorithm, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CRLDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerCreateCRL(issuerThumbprint, nextUpdate, updateExistingCRL, signatureAlgorithm, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerCreateCRL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {number} daysValid 
         * @param {CAControllerCreateSelfSignedCertificateKeyLengthEnum} keyLength 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {X500PrincipalRequest} x500PrincipalRequest 
         * @param {boolean} [whiteList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerCreateSelfSignedCertificate(email: string, daysValid: number, keyLength: CAControllerCreateSelfSignedCertificateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, x500PrincipalRequest: X500PrincipalRequest, whiteList?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<X509CertificateDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerCreateSelfSignedCertificate(email, daysValid, keyLength, signatureAlgorithm, x500PrincipalRequest, whiteList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerCreateSelfSignedCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerDeletePendingRequest(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerDeletePendingRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerDeletePendingRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerDeletePendingRequests(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerDeletePendingRequests(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerDeletePendingRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [certificates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerFinalizePendingRequest(certificates?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerFinalizePendingRequest(certificates, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerFinalizePendingRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CAKeyUsageFilter} keyUsageFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerGetAvailableCAs(keyUsageFilter: CAKeyUsageFilter, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<X509CertificateDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerGetAvailableCAs(keyUsageFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerGetAvailableCAs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerGetCertificateRequestHandlers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CertificateRequestHandlerDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerGetCertificateRequestHandlers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerGetCertificateRequestHandlers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerGetPendingRequest(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerGetPendingRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerGetPendingRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerGetPendingRequests(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerGetPendingRequests(firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerGetPendingRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {Match} match 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerGetPendingRequestsByEmail(email: string, match: Match, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerGetPendingRequestsByEmail(email, match, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerGetPendingRequestsByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {Match} match 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerGetPendingRequestsByEmailCount(email: string, match: Match, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerGetPendingRequestsByEmailCount(email, match, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerGetPendingRequestsByEmailCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerGetPendingRequestsCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerGetPendingRequestsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerGetPendingRequestsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {number} daysValid 
         * @param {CAControllerRequestNewCertificateKeyLengthEnum} keyLength 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {string} certificateRequestHandler 
         * @param {X500PrincipalRequest} x500PrincipalRequest 
         * @param {string} [crlDistributionPoint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerRequestNewCertificate(email: string, daysValid: number, keyLength: CAControllerRequestNewCertificateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, certificateRequestHandler: string, x500PrincipalRequest: X500PrincipalRequest, crlDistributionPoint?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NewRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerRequestNewCertificate(email, daysValid, keyLength, signatureAlgorithm, certificateRequestHandler, x500PrincipalRequest, crlDistributionPoint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerRequestNewCertificate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerRescheduleRequest(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PendingRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerRescheduleRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerRescheduleRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cAControllerRescheduleRequests(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cAControllerRescheduleRequests(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CAApi.cAControllerRescheduleRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CAApi - factory interface
 * @export
 */
export const CAApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CAApiFp(configuration)
    return {
        /**
         * 
         * @param {number} rootDaysValid 
         * @param {number} intermediateDaysValid 
         * @param {CAControllerCreateCARootKeyLengthEnum} rootKeyLength 
         * @param {CAControllerCreateCAIntermediateKeyLengthEnum} intermediateKeyLength 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {NewCASubjects} newCASubjects 
         * @param {string} [crlDistributionPoint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerCreateCA(rootDaysValid: number, intermediateDaysValid: number, rootKeyLength: CAControllerCreateCARootKeyLengthEnum, intermediateKeyLength: CAControllerCreateCAIntermediateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, newCASubjects: NewCASubjects, crlDistributionPoint?: string, options?: any): AxiosPromise<NewCAResponse> {
            return localVarFp.cAControllerCreateCA(rootDaysValid, intermediateDaysValid, rootKeyLength, intermediateKeyLength, signatureAlgorithm, newCASubjects, crlDistributionPoint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} issuerThumbprint 
         * @param {number} nextUpdate 
         * @param {boolean} updateExistingCRL 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerCreateCRL(issuerThumbprint: string, nextUpdate: number, updateExistingCRL: boolean, signatureAlgorithm: CACertificateSignatureAlgorithm, requestBody: Array<string>, options?: any): AxiosPromise<X509CRLDetails> {
            return localVarFp.cAControllerCreateCRL(issuerThumbprint, nextUpdate, updateExistingCRL, signatureAlgorithm, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {number} daysValid 
         * @param {CAControllerCreateSelfSignedCertificateKeyLengthEnum} keyLength 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {X500PrincipalRequest} x500PrincipalRequest 
         * @param {boolean} [whiteList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerCreateSelfSignedCertificate(email: string, daysValid: number, keyLength: CAControllerCreateSelfSignedCertificateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, x500PrincipalRequest: X500PrincipalRequest, whiteList?: boolean, options?: any): AxiosPromise<X509CertificateDetails> {
            return localVarFp.cAControllerCreateSelfSignedCertificate(email, daysValid, keyLength, signatureAlgorithm, x500PrincipalRequest, whiteList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerDeletePendingRequest(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.cAControllerDeletePendingRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerDeletePendingRequests(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.cAControllerDeletePendingRequests(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [certificates] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerFinalizePendingRequest(certificates?: File, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.cAControllerFinalizePendingRequest(certificates, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CAKeyUsageFilter} keyUsageFilter 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetAvailableCAs(keyUsageFilter: CAKeyUsageFilter, options?: any): AxiosPromise<Array<X509CertificateDetails>> {
            return localVarFp.cAControllerGetAvailableCAs(keyUsageFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetCertificateRequestHandlers(options?: any): AxiosPromise<Array<CertificateRequestHandlerDetails>> {
            return localVarFp.cAControllerGetCertificateRequestHandlers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequest(id: string, options?: any): AxiosPromise<PendingRequest> {
            return localVarFp.cAControllerGetPendingRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequests(firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<PendingRequest>> {
            return localVarFp.cAControllerGetPendingRequests(firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {Match} match 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequestsByEmail(email: string, match: Match, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<PendingRequest>> {
            return localVarFp.cAControllerGetPendingRequestsByEmail(email, match, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {Match} match 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequestsByEmailCount(email: string, match: Match, options?: any): AxiosPromise<number> {
            return localVarFp.cAControllerGetPendingRequestsByEmailCount(email, match, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerGetPendingRequestsCount(options?: any): AxiosPromise<number> {
            return localVarFp.cAControllerGetPendingRequestsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {number} daysValid 
         * @param {CAControllerRequestNewCertificateKeyLengthEnum} keyLength 
         * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
         * @param {string} certificateRequestHandler 
         * @param {X500PrincipalRequest} x500PrincipalRequest 
         * @param {string} [crlDistributionPoint] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerRequestNewCertificate(email: string, daysValid: number, keyLength: CAControllerRequestNewCertificateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, certificateRequestHandler: string, x500PrincipalRequest: X500PrincipalRequest, crlDistributionPoint?: string, options?: any): AxiosPromise<NewRequest> {
            return localVarFp.cAControllerRequestNewCertificate(email, daysValid, keyLength, signatureAlgorithm, certificateRequestHandler, x500PrincipalRequest, crlDistributionPoint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerRescheduleRequest(id: string, options?: any): AxiosPromise<PendingRequest> {
            return localVarFp.cAControllerRescheduleRequest(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cAControllerRescheduleRequests(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.cAControllerRescheduleRequests(requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CAApi - object-oriented interface
 * @export
 * @class CAApi
 * @extends {BaseAPI}
 */
export class CAApi extends BaseAPI {
    /**
     * 
     * @param {number} rootDaysValid 
     * @param {number} intermediateDaysValid 
     * @param {CAControllerCreateCARootKeyLengthEnum} rootKeyLength 
     * @param {CAControllerCreateCAIntermediateKeyLengthEnum} intermediateKeyLength 
     * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
     * @param {NewCASubjects} newCASubjects 
     * @param {string} [crlDistributionPoint] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerCreateCA(rootDaysValid: number, intermediateDaysValid: number, rootKeyLength: CAControllerCreateCARootKeyLengthEnum, intermediateKeyLength: CAControllerCreateCAIntermediateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, newCASubjects: NewCASubjects, crlDistributionPoint?: string, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerCreateCA(rootDaysValid, intermediateDaysValid, rootKeyLength, intermediateKeyLength, signatureAlgorithm, newCASubjects, crlDistributionPoint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} issuerThumbprint 
     * @param {number} nextUpdate 
     * @param {boolean} updateExistingCRL 
     * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerCreateCRL(issuerThumbprint: string, nextUpdate: number, updateExistingCRL: boolean, signatureAlgorithm: CACertificateSignatureAlgorithm, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerCreateCRL(issuerThumbprint, nextUpdate, updateExistingCRL, signatureAlgorithm, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {number} daysValid 
     * @param {CAControllerCreateSelfSignedCertificateKeyLengthEnum} keyLength 
     * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
     * @param {X500PrincipalRequest} x500PrincipalRequest 
     * @param {boolean} [whiteList] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerCreateSelfSignedCertificate(email: string, daysValid: number, keyLength: CAControllerCreateSelfSignedCertificateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, x500PrincipalRequest: X500PrincipalRequest, whiteList?: boolean, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerCreateSelfSignedCertificate(email, daysValid, keyLength, signatureAlgorithm, x500PrincipalRequest, whiteList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerDeletePendingRequest(id: string, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerDeletePendingRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerDeletePendingRequests(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerDeletePendingRequests(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [certificates] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerFinalizePendingRequest(certificates?: File, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerFinalizePendingRequest(certificates, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CAKeyUsageFilter} keyUsageFilter 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerGetAvailableCAs(keyUsageFilter: CAKeyUsageFilter, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerGetAvailableCAs(keyUsageFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerGetCertificateRequestHandlers(options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerGetCertificateRequestHandlers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerGetPendingRequest(id: string, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerGetPendingRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerGetPendingRequests(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerGetPendingRequests(firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {Match} match 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerGetPendingRequestsByEmail(email: string, match: Match, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerGetPendingRequestsByEmail(email, match, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {Match} match 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerGetPendingRequestsByEmailCount(email: string, match: Match, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerGetPendingRequestsByEmailCount(email, match, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerGetPendingRequestsCount(options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerGetPendingRequestsCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {number} daysValid 
     * @param {CAControllerRequestNewCertificateKeyLengthEnum} keyLength 
     * @param {CACertificateSignatureAlgorithm} signatureAlgorithm 
     * @param {string} certificateRequestHandler 
     * @param {X500PrincipalRequest} x500PrincipalRequest 
     * @param {string} [crlDistributionPoint] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerRequestNewCertificate(email: string, daysValid: number, keyLength: CAControllerRequestNewCertificateKeyLengthEnum, signatureAlgorithm: CACertificateSignatureAlgorithm, certificateRequestHandler: string, x500PrincipalRequest: X500PrincipalRequest, crlDistributionPoint?: string, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerRequestNewCertificate(email, daysValid, keyLength, signatureAlgorithm, certificateRequestHandler, x500PrincipalRequest, crlDistributionPoint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerRescheduleRequest(id: string, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerRescheduleRequest(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CAApi
     */
    public cAControllerRescheduleRequests(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CAApiFp(this.configuration).cAControllerRescheduleRequests(requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CAControllerCreateCARootKeyLengthEnum = {
    NUMBER_2048: 2048,
    NUMBER_3072: 3072,
    NUMBER_4096: 4096
} as const;
export type CAControllerCreateCARootKeyLengthEnum = typeof CAControllerCreateCARootKeyLengthEnum[keyof typeof CAControllerCreateCARootKeyLengthEnum];
/**
 * @export
 */
export const CAControllerCreateCAIntermediateKeyLengthEnum = {
    NUMBER_2048: 2048,
    NUMBER_3072: 3072,
    NUMBER_4096: 4096
} as const;
export type CAControllerCreateCAIntermediateKeyLengthEnum = typeof CAControllerCreateCAIntermediateKeyLengthEnum[keyof typeof CAControllerCreateCAIntermediateKeyLengthEnum];
/**
 * @export
 */
export const CAControllerCreateSelfSignedCertificateKeyLengthEnum = {
    NUMBER_2048: 2048,
    NUMBER_3072: 3072,
    NUMBER_4096: 4096
} as const;
export type CAControllerCreateSelfSignedCertificateKeyLengthEnum = typeof CAControllerCreateSelfSignedCertificateKeyLengthEnum[keyof typeof CAControllerCreateSelfSignedCertificateKeyLengthEnum];
/**
 * @export
 */
export const CAControllerRequestNewCertificateKeyLengthEnum = {
    NUMBER_2048: 2048,
    NUMBER_3072: 3072,
    NUMBER_4096: 4096
} as const;
export type CAControllerRequestNewCertificateKeyLengthEnum = typeof CAControllerRequestNewCertificateKeyLengthEnum[keyof typeof CAControllerRequestNewCertificateKeyLengthEnum];
